import { render, staticRenderFns } from "./ParceirosSlider.vue?vue&type=template&id=daef9a5a&scoped=true"
import script from "./ParceirosSlider.vue?vue&type=script&lang=js"
export * from "./ParceirosSlider.vue?vue&type=script&lang=js"
import style0 from "./ParceirosSlider.vue?vue&type=style&index=0&id=daef9a5a&prod&lang=scss"
import style1 from "./ParceirosSlider.vue?vue&type=style&index=1&id=daef9a5a&prod&lang=scss&scoped=true"
import style2 from "./ParceirosSlider.vue?vue&type=style&index=2&id=daef9a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daef9a5a",
  null
  
)

export default component.exports